import type { ReactNode } from "react";
import "./modal.css";
import { Button } from "../button";
import { Icon } from "../icon";

interface ConfirmModalProps {
  children?: ReactNode | string;  
  isOpen: boolean;
  title: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "primary" | "destructive";
  onConfirm: () => void;
  onCancel: () => void;
}

export default function Modal({
  children, 
  isOpen,
  title,
  confirmText = "Supprimer",
  cancelText = "Annuler",
  variant = "primary",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          {variant == "destructive" && <div className="modal-icon-warning-container">
            <Icon className="modal-icon-warning" name="warning"/>
          </div>
          }
          <h2>{title}</h2>
        </div>
        <div className="modal-body">
          {children}
        </div>
        <div className="modal-footer">
            <Button 
                onClick={onCancel}
                variant="soft"
                label={cancelText}>
            </Button>
            <Button 
                onClick={onConfirm}
                variant={variant}
                label={confirmText}>
            </Button>
        </div>
      </div>
    </div>
  );
}